var link_preview_default = {
  "fontElementMap": "-grcO",
  "linkPreview": "_8o65b",
  "linkPreviewImage": "mCffn",
  "linkPreviewInfo": "cGo5T",
  "linkPreviewTitle": "Bp92z",
  "ellipsis": "L9vi9",
  "linkPreviewDescription": "HvTrs",
  "linkPreviewUrl": "NSMad"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
